import {useState} from "react";
import {contactForm} from "../../util/request.ts";

// TODO: Maybe this comes from API? or useless to lookup on each page load
const Categories = [
    {id: 1, name: 'Hjælp til bestillingen'},
    {id: 2, name: 'Jeg er offline'},
    {id: 3, name: 'Teknisk problem'},
    {id: 4, name: 'Min regning'},
    {id: 5, name: 'Ris & ros'},
    {id: 6, name: 'Andet'},
];

export default function ContactFormComponent() {
    const [selectedCategory, setSelectedCategory] = useState<number | undefined>(undefined);
    const [selectedCategoryError, setSelectedCategoryError] = useState<boolean>(false);

    const [streetName, setStreetName] = useState<string>("");

    const [streetNumber, setStreetNumber] = useState<string>("");

    const [streetFloor, setStreetFloor] = useState<string>("");

    const [streetSide, setStreetSide] = useState<string>("");

    const [streetZip, setStreetZip] = useState<string>("");

    const [name, setName] = useState<string>("");
    const [nameError, setNameError] = useState<boolean>(false);

    const [email, setEmail] = useState<string>("");
    const [emailError, setEmailError] = useState<boolean>(false);

    const [mobile, setMobile] = useState<string>("");
    const [mobileError, setMobileError] = useState<boolean>(false);

    const [comment, setComment] = useState<string>("");
    const [commentError, setCommentError] = useState<boolean>(false);

    const [submitting, setSubmitting] = useState<boolean>(false);
    const [submissionSuccess, setSubmissionSuccess] = useState<boolean>(false);

    const [submissionErrorMessage, setSubmissionErrorMessage] = useState<string>("");

    const validateForm = () => {
        let anyError = false;

        if (typeof selectedCategory !== "number") {
            setSelectedCategoryError(true);
            anyError = true;
        } else {
            setSelectedCategoryError(false);
        }

        if (name.length < 2) {
            setNameError(true);
            anyError = true;
        } else {
            setNameError(false);
        }

        if (email.length < 2) {
            setEmailError(true);
            anyError = true;
        } else {
            setEmailError(false);
        }

        if (mobile.length < 8) {
            setMobileError(true);
            anyError = true;
        } else {
            setMobileError(false);
        }

        if (comment.length < 3) {
            setCommentError(true);
            anyError = true;
        } else {
            setCommentError(false);
        }

        return anyError
    }

    if (submitting) {
        return (
            <div className={'content'}>
                <h3 className="heading heading--small heading--blue">Sender din besked</h3>
            </div>
        )
    }

    if (submissionSuccess) {
        return (
            <div className={'content'}>
                <p className={'align-center'}>Vi har registreret din henvendelse og vil kontakte dig hurtigst muligt.</p>
            </div>
        )
    }

    return (
        <>
            <form className="contact-form">
                <div className="contact-form__grid contact-form__grid-3 contact-form__categories">
                    {Categories.map((category, index) => {
                        return (
                            <div key={index} className="contact-form__grid-item">
                                <input
                                    type="radio" id={`category-${category.id}`} value={category.id}
                                    checked={selectedCategory === category.id}
                                    onChange={(e) => setSelectedCategory(parseInt(e.target.value))}
                                    required
                                    className={selectedCategoryError ? 'error' : ''}
                                />
                                <label htmlFor={`category-${category.id}`} className="checkbox-label checkbox-label--box">{category.name}</label>
                            </div>
                        )
                    })}
                </div>
                {selectedCategory === 1 && (
                    <div className="contact-form--address-container">
                        <p>Indtast din adresse, så vi kan hjælpe dig hurtigere</p>
                        <div className="contact-form__grid-address">
                            <div className="contact-form__grid-address-item">
                                <input
                                    type="text"
                                    tabIndex={-1}
                                    placeholder="Gade / vej"
                                    value={streetName}
                                    onChange={(e) => setStreetName(e.target.value)}
                                />
                            </div>
                            <div className="contact-form__grid-address-item">
                                <input
                                    type="text"
                                    tabIndex={-1}
                                    placeholder="Hus nr."
                                    value={streetNumber}
                                    onChange={(e) => setStreetNumber(e.target.value)}
                                />
                            </div>
                            <div className="contact-form__grid-address-item">
                                <input
                                    type="text"
                                    tabIndex={-1}
                                    placeholder="Etage"
                                    value={streetFloor}
                                    onChange={(e) => setStreetFloor(e.target.value)}
                                />
                            </div>
                            <div className="contact-form__grid-address-item">
                                <input
                                    type="text"
                                    tabIndex={-1}
                                    placeholder="Side"
                                    value={streetSide}
                                    onChange={(e) => setStreetSide(e.target.value)}
                                />
                            </div>
                            <div className="contact-form__grid-address-item">
                                <input
                                    type="text"
                                    tabIndex={-1}
                                    placeholder="Postnr."
                                    value={streetZip}
                                    onChange={(e) => setStreetZip(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                )}
                <p>
                    <input
                        type="text"
                        placeholder="Dit navn"
                        required
                        value={name}
                        className={nameError ? 'error' : ''}
                        onChange={(e) => setName(e.target.value)}
                    />
                </p>
                <div className="contact-form__grid contact-form__grid-2">
                    <div className="contact-form__grid-item">
                        <input
                            type="email"
                            placeholder="Email"
                            required
                            value={email}
                            className={emailError ? 'error' : ''}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="contact-form__grid-item">
                        <input
                            type="tel"
                            placeholder="Mobil"
                            required
                            value={mobile}
                            className={mobileError ? 'error' : ''}
                            onChange={(e) => setMobile(e.target.value)}
                        />
                    </div>
                </div>
                <p>
            <textarea
                placeholder="Spørgsmål eller kommentar"
                required
                value={comment}
                className={commentError ? 'error' : ''}
                onChange={(e) => setComment(e.target.value)}
            ></textarea>
                </p>
                <p>
                    <input
                        value={"send"}
                        disabled={submitting}
                        type="submit"
                        className="button"
                        onClick={(e) => {
                            e.preventDefault()

                            const anyError = validateForm()
                            if (anyError) {
                                return;
                            }

                            setSubmitting(true)
                            contactForm(
                                selectedCategory as number,
                                streetName,
                                streetNumber,
                                streetFloor,
                                streetSide,
                                streetZip,
                                name,
                                email,
                                mobile,
                                comment,
                            ).then(r => {
                                if (r.code === 201) {
                                    setSubmissionSuccess(true)
                                    return
                                } else {
                                    setSubmissionErrorMessage("Noget gik galt")
                                }

                                setSubmissionSuccess(false)
                            }).finally(() => {
                                setSubmitting(false)
                            })
                        }}
                    />
                </p>
                {submissionErrorMessage.length > 0 && (
                    <p>{submissionErrorMessage}</p>
                )}
            </form>
        </>
    )
}
